// How an order's status reads depending on whether it is delivered or collected. Same words as src/pickup.js (the server's copy).
const LABELS = {
  delivery: { paid: 'Paid', processing: 'Processing', shipped: 'Shipped', delivered: 'Delivered' },
  pickup:   { paid: 'Paid', processing: 'Preparing', shipped: 'Ready for collection', delivered: 'Collected' },
};

export const isPickup = (order) => order?.fulfilment === 'pickup';

/** The label for a status on this order, or null when the status has no special wording (cancelled, pending…). */
export function statusLabel(status, fulfilment) {
  return LABELS[fulfilment === 'pickup' ? 'pickup' : 'delivery'][status] || null;
}
